import {http} from "@/config/HttpClient";
import {Alert} from "@/addons/Alert";
import {reportesBancoStore} from "@/store/reportesBancoStore";

export class ReportesBancoService {
    private static instance: ReportesBancoService;
    public static getInstance() {
        return this.instance || (this.instance = new this());
    }

    reportesBancoStore = reportesBancoStore();

    public resumenTotalizado(data: any) {
        this.reportesBancoStore.loading = true;
        http.get("reportesBanco/resumenTotalizado", {params: data}).subscribe({
            next: (response: any) => {
                if (response && response.data) {
                    this.reportesBancoStore.resumenTotalizado = response.data.data || [];
                    this.reportesBancoStore.resumenTotalizadoTotales = response.data.totales || {};
                }
                this.reportesBancoStore.loading = false;
            },
            error: (error: any) => {
                const errorMsg = error?.response?.data?.message || error?.message || 'Error desconocido';
                Alert.error(errorMsg);
                this.reportesBancoStore.loading = false;
            }
        })
    }
}
